import { render, staticRenderFns } from "./CardView.vue?vue&type=template&id=bb04071e&scoped=true&lang=pug"
import script from "./CardView.vue?vue&type=script&lang=js"
export * from "./CardView.vue?vue&type=script&lang=js"
import style0 from "./CardView.vue?vue&type=style&index=0&id=bb04071e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb04071e",
  null
  
)

export default component.exports